import { defineComponent as _defineComponent } from 'vue'
import { useCourseTakeStore } from '@/stores/trainings/courseTake';
  import { storeToRefs } from 'pinia';
  import { COURSE_TYPE } from '@/entities/trainings';
  import type { CompletedStep } from '@/entities/trainings';
  import Section from '@/ui/components/trainings/courseTake/types/Section.vue';
  import Text from '@/ui/components/trainings/courseTake/types/Text.vue';
  import Completed from '@/ui/components/trainings/courseTake/types/Completed.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ActiveItem',
  setup(__props) {

  const courseTake = useCourseTakeStore();
  const { activeItem } = storeToRefs(courseTake);

  const componentFor = (type: COURSE_TYPE | CompletedStep['type']) => {
    switch (type) {
      case COURSE_TYPE.SECTION:
        return Section;

      case COURSE_TYPE.TEXT:
        return Text;

      case 'completed':
        return Completed;

      default:
        return null;
    }
  };

return { __sfc: true,courseTake, activeItem, componentFor }
}

})